import { Link } from "react-router-dom";
import { ArrowRight, FileText, Waves, Building2, Trophy } from "lucide-react";

/**
 * Proposals index — landing page for all outbound proposals from Sterile Mate.
 * Public route: /proposals
 */
export default function ProposalsIndexPage() {
  const proposals = [
    {
      id: "living-waters",
      title: "Living Waters US — Exclusive Distribution",
      subtitle: "5-year exclusive Sales & Distribution agreement · Government · Retail · Events · Airport",
      brand: "Living Waters US",
      status: "Ready to send",
      value: "$3.56M 3-yr net revenue to LW · $627K commission to Bleu Flux",
      route: "/proposals/living-waters",
      icon: Waves,
      accent: "from-blue-950 via-blue-900 to-cyan-700",
    },
  ];

  return (
    <div className="min-h-screen bg-slate-100 py-10 px-4" data-testid="proposals-index-page">
      <div className="max-w-5xl mx-auto">
        <header className="mb-8">
          <p className="text-xs font-bold tracking-[0.3em] text-cyan-700 uppercase">Sterile Mate LLC · DBA Bleu Flux</p>
          <h1 className="text-4xl font-black text-blue-950 mt-2">Proposals</h1>
          <p className="text-slate-600 mt-2 max-w-2xl">
            Outbound partnership, distribution, and vendor proposals authored by the Sterile Mate / Bleu Flux team. Each proposal is print-ready and shareable via a public URL.
          </p>
        </header>

        <div className="space-y-4">
          {proposals.map((p) => {
            const Icon = p.icon;
            return (
              <Link
                key={p.id}
                to={p.route}
                data-testid={`proposal-card-${p.id}`}
                className="block group"
              >
                <article className={`relative overflow-hidden rounded-xl bg-gradient-to-br ${p.accent} p-8 shadow-lg hover:shadow-2xl transition-all`}>
                  <div className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-16 h-16 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20">
                      <Icon className="w-8 h-8 text-amber-400" />
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-bold text-amber-400 uppercase tracking-widest">{p.brand}</p>
                      <h2 className="text-2xl font-bold text-white mt-1">{p.title}</h2>
                      <p className="text-blue-100 mt-2 text-sm leading-6">{p.subtitle}</p>
                      <div className="mt-4 flex flex-wrap items-center gap-3">
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-400/40 text-emerald-100 text-xs font-semibold">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                          {p.status}
                        </span>
                        <span className="text-amber-300 text-xs font-mono font-semibold">{p.value}</span>
                      </div>
                    </div>
                    <ArrowRight className="w-6 h-6 text-white/60 group-hover:text-white group-hover:translate-x-1 transition-transform" />
                  </div>
                </article>
              </Link>
            );
          })}
        </div>

        <div className="mt-10 rounded-xl border-2 border-dashed border-slate-300 p-8 text-center">
          <FileText className="w-10 h-10 text-slate-400 mx-auto" />
          <p className="mt-3 text-sm font-semibold text-slate-600">More proposals coming</p>
          <p className="text-xs text-slate-500 mt-1">City of Houston &middot; Harris County Airport System &middot; Retail chain intros</p>
        </div>
      </div>
    </div>
  );
}
